/**
 * Sponsor applications API — `/admin/sponsor/...` on the px backend.
 *
 * Applications come from the website sponsor form (pxmine.com/sponsors.html).
 * The panel reviews them: status (pending → in review → approved / rejected)
 * plus an internal note. Nothing here contacts the applicant.
 */

const getApiBase = () => {
  const base = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
  return base.endsWith("/admin") ? `${base}/sponsor` : `${base}/admin/sponsor`;
};

const headers = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const handleResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.status === false) {
    const err = new Error(data?.message || data?.error || `Request failed with status ${response.status}`);
    err.response = data;
    throw err;
  }
  return data;
};

const request = async (method, path, body) => {
  const res = await fetch(`${getApiBase()}${path}`, {
    method,
    headers: headers(),
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  return handleResponse(res);
};

export const fetchSponsorApplications = ({ status = "pending", pkg = "", type = "", search = "", page = 1, limit = 25 } = {}) => {
  const query = new URLSearchParams();
  if (status) query.append("status", status);
  if (pkg) query.append("package", pkg);
  if (type) query.append("type", type);
  if (search) query.append("search", search.trim());
  query.append("page", page);
  query.append("limit", limit);
  return request("GET", `/applications?${query.toString()}`);
};

export const fetchSponsorApplication = (id) => request("GET", `/applications/${encodeURIComponent(id)}`);

export const updateSponsorApplication = (id, body) => request("PUT", `/applications/${encodeURIComponent(id)}`, body);

export const deleteSponsorApplication = (id) => request("DELETE", `/applications/${encodeURIComponent(id)}`);
